import React from 'react'
import { RiPercentFill } from 'react-icons/ri'

const percentageCompleted = props => {
  return (
    <div className='col-lg-3 column-lmd-2-half column-md-2-full'>
      <div className='icon-box d-flex align-items-center'>
        <div className='icon-element icon-element-bg-3 flex-shrink-0'>
          <RiPercentFill />
        </div>
        <div className='info-content'>
          <h4 className='info__title mb-2'>% de conclusão</h4>
          <span className='info__count'>{props.data}</span>
        </div>
      </div>
    </div>
  )
}

export default percentageCompleted
